<template>
    <el-container>
        <el-header height="20vh">
            <img src="../assets/mete_logo.png" style="position: absolute; z-index: 2; width: 20%;" @click="goMETE"/>
            <el-image :src="require('@/assets/tracking_hd.jpg')" fit="cover" style="width: 100%; height: 100%;"></el-image>
        </el-header>
        <el-main>
            <el-scrollbar height="100%">
                <el-row type="flex" justify="center">
                    <el-col :xs="24" :sm="16" :md="12" :lg="8" :xl="6">
                        <!-- 包裹查詢 -->
                        <el-collapse-transition>
                            <div id="search-form" class="search-style" v-show="show">
                                <el-card class="box-card">
                                    <el-row type="flex" style="padding-left: 30px">
                                        <h2>包裹查詢</h2>
                                    </el-row>
                                    <el-row type="flex" style="padding-left: 30px">
                                        <ul style="margin-top: 0; padding: 0;">
                                            <li>請輸入欲查詢的託運單號碼，含英文+數字</li>
                                            <li>英文大小寫不限</li>
                                            <li>僅提供最近三個月內貨件資訊供查詢</li>
                                        </ul>
                                    </el-row>
                                    <el-form ref="formRef" :model="form" label-width="30px" :size="size">
                                        <el-form-item v-for="i in 5" :key="`${i}`" :label="`${i}`" :prop="`STOCK_${i}`">
                                            <el-input v-model="form[`STOCK_${i}`]"></el-input>
                                        </el-form-item>
                                    </el-form>
                                    <el-row :gutter="10" style="padding-left: 30px">
                                        <el-col :span="12">
                                            <el-button @click="onResetClick" style="float: right; width: 100%;">清空重填</el-button>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-button type="primary" @click="onSendClick" style="width: 100%;">送出查詢</el-button>
                                        </el-col>
                                    </el-row>
                                </el-card>
                            </div>
                        </el-collapse-transition>
                        <el-collapse-transition>
                            <!-- 查詢結果 -->
                            <div id="search-result" class="search-style" v-show="!show">
                                <h2>查詢結果</h2>
                                <template v-for="(result, index) in formData" :key="index">
                                    <el-row v-if="result.DLV_NO !=''" style="margin-bottom: 20px">
                                        <el-col>
                                            <el-card class="box-card">
                                                <template #header>
                                                    <div class="card-header">
                                                        <el-row type="flex" justify="space-between">
                                                            <el-col><span class="text-primary">託運單號碼{{index + 1}}</span></el-col>
                                                            <span class="track-info">{{result.DLV_NO}}</span>
                                                            <el-button class="icon-darrowdown" plain @click="onMoreInfoClick(result)" :disabled="result.LAST_STATUS_CODE==null"></el-button>
                                                        </el-row>
                                                    </div>
                                                </template>
                                                <el-row type="flex" justify="space-between">
                                                    <el-col :span="12">
                                                        <span class="text-primary">最新狀態</span>
                                                        <br />
                                                        <span class="track-info">{{ result.LAST_STATUS_DESC }}</span>
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <span class="text-primary">作業時間</span>
                                                        <br />
                                                        <span class="track-info">{{ result.LAST_STATUS_TIME }}</span>
                                                    </el-col>
                                                </el-row>
                                            </el-card>
                                        </el-col>
                                    </el-row>
                                </template>
                                <el-row type="flex" justify="center">
                                    <el-button type="primary" @click="onResearchClick" style="width: 100%;">重新查詢</el-button>
                                </el-row>
                            </div>
                        </el-collapse-transition>
                    </el-col>
                </el-row>
            </el-scrollbar>
        </el-main>
    </el-container>
    <el-dialog v-model="dialogVisible" width="94%" style="max-width: 500px; min-width: 300px">
        <template #title>
            <span class="text-primary el-dialog__title">託運單號碼：</span>
            <span class="el-dialog__title">{{dialogTitle}}</span>
        </template>
        <el-row type="flex" justify="center">
            <ul class="el-timeline" style="padding-left: 0; padding-right: 20px">
                <template v-for="(detail, index) in detailData" :key="index">
                    <li class="el-timeline-item" style="width: fit-content">
                        <div class="el-timeline-item__wrapper" style="padding: 0">
                            <div class="el-timeline-item__timestamp is-top" style="text-align: end">
                            <h3>{{ detail.STATUS_DATE }}<br>{{ detail.STATUS_TIME }}</h3>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
            <ul class="el-timeline" style="padding: 0">
                <template v-for="(detail, index) in detailData" :key="index">
                    <li class="el-timeline-item">
                        <div class="el-timeline-item__tail"></div>
                        <div class="el-timeline-item__node el-timeline-item__node--normal" :style="{'background-color': (index == 0) ? 'deepskyblue' : ''}"></div>
                        <div class="el-timeline-item__wrapper">
                            <div class="el-timeline-item__content">
                                <h3>{{ detail.STATUS_DESC }}</h3>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
        </el-row>
    </el-dialog>
</template>

<script setup>
    import { ref } from 'vue'
    import $api from '@/utils/axios';
    import { MoreFilled } from '@element-plus/icons-vue'

    const size = ref('large');

    const show = ref(true);
    const dialogVisible = ref(false);
    const dialogTitle = ref("");

    const formRef = ref(null);
    const form = ref({
        STOCK_1: '',
        STOCK_2: '',
        STOCK_3: '',
        STOCK_4: '',
        STOCK_5: '',
    });

    const formData = ref([]);
    const detailData = ref([]);

    const onSendClick = () => {
        $api.POST('/api/Tracking/GetData', form.value
        ).then((response) => {
            formData.value = response;
            show.value = false;
        });
    }

    const onResetClick = () => {
        formRef.value.resetFields();
    }

    const onMoreInfoClick = (result) => {
        detailData.value = result.Status;
        dialogTitle.value = result.DLV_NO;
        dialogVisible.value = true;
    }

    const onResearchClick = () => {
        formRef.value.resetFields();
        formData.value = [];
        detailData.value = [];
        show.value = true;
    }

    const goMETE = () => {
        window.open("https://metetw.com/", "_blank");
    }
</script>
<style scoped lang="scss">
    h3 {
        margin: 0;
        font-weight: normal;
    }
    .el-container, .el-main {
        height: 100%;
    }
    .el-header {
        padding: 0;
    }

    .el-timeline-item__wrapper {
        height: 40px;
    }

    .track-info {
        font-size: 1.17em;
        line-height: 32px;
    }

    .text-primary {
        color: deepskyblue;
    }

    .icon-darrowdown {
        background-image: url("../assets/icon_darrowdown.png") !important;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 20px 20px;
    }

    .el-button.is-disabled {
        opacity: 0.5;
    }

    .search-style {
        margin: 10px;
        border-radius: 4px;
        padding: 10px 15px;
    }
</style>